<template>
  <detail-layout-two-columns-no-fixed-collapsible :custom-right="summaryWidth" :collapsed="collapsed" @update:collapsed="$emit('update:collapsed', $event)">
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
      </div>
    </template>
    <template slot="LeftCol">
      <div ref="step-wrapper" class="invoice-step h-full px-4 lg:px-10">
        <div class="loader" v-if="isAnimationLoading">
          <loading :opacity="0" :active.sync="isAnimationLoading" color="var(--primary-DEFAULT)"></loading>
        </div>
        <step-0-issuer ref="embedded-step-0" class="embedded-step h-full" :is-first-step="isFirstStep" :step="step0" :value="value" @toggleFilters="toggleStep0Filters" @change="issuerChange" @reset="$emit('reset', $event)" @input="step0Input" />
        <step-1-receiver v-if="form.issuer && issuingType !== 4" ref="embedded-step-1" class="embedded-step h-full mt-4" :is-first-step="isFirstStep" :step="step1" :value="value" @toggleFilters="toggleStep1Filters" @applystep="applystep" @input="step1Input" />
      </div>
    </template>
    <template slot="RightCol">
      <slot name="invoice-summary" />
    </template>
    <template slot="layout-extend">
      <step-0-filter-panel :panelOpen="step0FilterPanel" @togglePanel="toggleStep0Filters" @applyFilters="applyStep0FiltersHandler" />
      <step-1-filter-panel :panelOpen="step1FilterPanel" @togglePanel="toggleStep1Filters" @applyFilters="applyStep1FiltersHandler" />
      <slot name="layout-extend" :valid="form.issuer && form.receiver" />
    </template>
  </detail-layout-two-columns-no-fixed-collapsible>
</template>

<script>
import { i18n } from '@/i18n'
import waitUntil from '@/services/functions/waitUntil'

import DetailLayoutTwoColumnsNoFixedCollapsible from '@/components/layout/DetailLayoutTwoColumnsNoFixedCollapsible.vue'
import Step0Issuer from '@/views/invoices/issuingSteps/Step0Issuer.vue'
import Step1Receiver from '@/views/invoices/issuingSteps/Step1Receiver.vue'
import Step0FilterPanel from '@/components/filters/Step0Filter.vue'
import Step1FilterPanel from '@/components/filters/Step1Filter.vue'
import Loading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'step01-partes',
  components: {
    // Loading,
    DetailLayoutTwoColumnsNoFixedCollapsible,
    Step0Issuer,
    Step1Receiver,
    Step0FilterPanel,
    Step1FilterPanel,
    Loading,
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
    summaryWidth: {
      type: [Array, Object, String],
      default: 'w-full'
    },
    collapsed: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      stepId: '01',
      step0FilterPanel: false,
      step1FilterPanel: false,
      isAnimationLoading: false
    }
  },
  computed: {
    ...mapGetters('invoicesIssuing', ['issuingType']),
    form: function () {
      const step0Form = this.$store.getters['invoicesIssuing/0/form']
      const step1Form = this.$store.getters['invoicesIssuing/1/form']
      return {
        ...step0Form,
        ...step1Form
      }
    },
    steps: function () {
      const steps = {
        0: { stepId: '0', title: i18n.t('invoices.emisor'), icon: '', description: i18n.t('invoices.invoices_issuing.step0.header') },
        1: { stepId: '1', title: i18n.t('invoices.receptor'), icon: '', description: i18n.t('invoices.invoices_issuing.step1.header') },
      }
      if (this.issuingType === 2) {
        steps[0].description = i18n.t('invoices.invoices_issuing.step0.p_header')
        steps[1].description = i18n.t('invoices.invoices_issuing.step1.p_header')
      } else if (this.issuingType === 3) {
        steps[0].description = i18n.t('invoices.invoices_issuing.step0.q_header')
        steps[1].description = i18n.t('invoices.invoices_issuing.step1.q_header')
      }
      return steps
    },
    step0: function () {
      return this.steps[0]
    },
    step1: function () {
      return this.steps[1]
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
  },
  mounted () {
    if (this.isIssuingCreation) {
      this.isAnimationLoading = true
      this.prepareStep1()
      this.$nextTick(async () => {
        await waitUntil(() => !this.isGeneralLoading)
        this.scrollToStep1()
      })
    } else {
      this.prepareStep1()
    }
  },
  methods: {
    scrollToStep1: function () {
      const scrollContainer = this.$refs['step-wrapper'].closest('.left-col')
      if (this.$refs['embedded-step-1']?.$el && scrollContainer) {
        try {
          this.isAnimationLoading = true
          var options = {
            container: scrollContainer,
            force: true,
            cancelable: false,
            onStart: element => { this.isAnimationLoading = true },
            onDone: element => { this.isAnimationLoading = false }
          }
          this.$scrollTo(this.$refs['embedded-step-1'].$el, 1000, options)
        } catch {
          this.isAnimationLoading = false
        }
      }
    },
    prepareStep1: function () {
      if (this.form.issuer && this.$refs['embedded-step-1']) {
        this.$refs['embedded-step-1'].prepareStep()
      }
    },
    resetStep1: function (excluded) {
      if (this.$refs['embedded-step-1']) {
        this.$refs['embedded-step-1'].resetForm(excluded)
      }
    },
    resetForm: function (excluded = []) {
      if (!excluded.includes(this.stepId)) {
        this.$refs['embedded-step-0'].resetForm(excluded)
        this.resetStep1(excluded)
      }
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs['embedded-step-0'].validate(valid => {
        if (this.$refs['embedded-step-1']) {
          this.$refs['embedded-step-1'].validate(valid2 => callback(valid && valid2))
        } else {
          callback(valid)
        }
      })
    },
    issuerChange: function (issuer) {
      this.resetStep1()
      if (issuer) {
        if (!this.form.issuer) {
          this.form.issuer = issuer
        }
        if (this.issuingType !== 4) {
          this.isAnimationLoading = true
          this.$nextTick(async () => {
            this.prepareStep1()
            await waitUntil(() => !this.isGeneralLoading)
            this.scrollToStep1()
          })
        } else {
          this.applystep()
        }
      }
    },
    applystep: function () {
      this.$emit('applystep')
    },
    toggleStep0Filters: function () {
      this.step1FilterPanel = false
      this.step0FilterPanel = !this.step0FilterPanel
    },
    applyStep0FiltersHandler: async function (eventData) {
      if (typeof this.$refs['embedded-step-0']?.applyFiltersHandler === 'function') {
        this.$refs['embedded-step-0'].applyFiltersHandler(eventData)
      }
    },
    toggleStep1Filters: function () {
      this.step0FilterPanel = false
      this.step1FilterPanel = !this.step1FilterPanel
    },
    applyStep1FiltersHandler: async function (eventData) {
      if (typeof this.$refs['embedded-step-1']?.applyFiltersHandler === 'function') {
        this.$refs['embedded-step-1'].applyFiltersHandler(eventData)
      }
    },
    step0Input: function (event) {
      this.$emit('input', event)
    },
    step1Input: function (event) {
      if (this.value === '' && event !== '') {
        this.$emit('input', event)
      }
    }
  },
}
</script>

<style scoped>
.layout-detail-two-columns::v-deep .left-col {
  overflow-x: hidden;
}
.invoice-step > div:not(:first-child) {
  margin-top: 5px;
}
.invoice-step > div:not(:last-child) {
  margin-bottom: 5px;
}

@media (min-width: 1024px) {
  .embedded-step::v-deep.content-wrapper,
  .aside-is-collapsed .embedded-step::v-deep.content-wrapper {
    width: 100%;
  }
}
</style>
